import template from './permitted-use-type.jade';
import items from '../../../enums/permitted-use-type';

export default angular
    .module('cian.addForm.aboutObjectPermittedUseType', [])
    .directive('cianAfAboutObjectPermittedUseType', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller: ['deviceService', function (deviceService) {
            this.isMobile = deviceService.isMobile;
            this.items = items;
        }],
        controllerAs: 'permittedUseType',
        template,
    }))
    .name;
